<template>
	<v-select
		v-model="mValue"
		:items="items"
		:label="label"
		:multiple="multiple"
		:clearable="clearable"
		v-bind="$attrs"
	/>
</template>

<script>
export default {
	props: {
		value: { type: String },
		label: { type: String, default: 'Division' },
		multiple: { type: Boolean, default: true },
		clearable: { type: Boolean, default: true },
	},
	computed: {
		mValue: {
			get () {
				if (!this.value) { return [] }
				return this.value.split(',')
			},
			set (v) {
				if (!v.length) {
					this.$emit('input', null)
				} else {
					this.$emit('input', v.join(','))
				}
			},
		},
		items () {
            return [...this.raw_divisions]
        },
	},
}
</script>
